import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useRef, useState } from "react";
import { YandexApi } from "@jti/rest-api";
import { DEPRECATED_TextInput } from "../../../../components/DEPRECATED_TextInput";
import { useOutsideClick } from "../../../../hooks/useOutsideClick";
import { useConfig } from "../../../../providers/useConfig";
import { useTranslations } from "../../../../providers/useTranslations";
import styles from "./YandexPlaceInput.module.scss";
const getValueByKind = (suggestion, searchString) => {
    return suggestion.address.component.find(({ kind }) => kind?.includes(searchString))?.name ?? "";
};
const prepareYandexAutocompleteResults = (suggestion) => {
    return {
        city: getValueByKind(suggestion, "LOCALITY"),
        streetName: getValueByKind(suggestion, "STREET"),
        streetNumber: getValueByKind(suggestion, "HOUSE"),
        postcode: "",
        provinceName: "",
        districtName: "",
    };
};
const filterResultsByCountry = (results, countryName) => {
    return results.filter(({ address }) => address?.formatted_address &&
        address.component?.some(({ kind, name }) => kind?.includes("COUNTRY") && name === countryName));
};
export const YandexPlaceInput = forwardRef(({ onPlace, onChange, value, ...props }, ref) => {
    const { __ } = useTranslations();
    const [suggestions, setSuggestions] = useState([]);
    const dropDownContainerRef = useRef(null);
    const { COUNTRY_NAME } = useConfig();
    useOutsideClick(dropDownContainerRef, () => setSuggestions([]));
    const yandexApi = YandexApi.init();
    const fetchSuggestions = async (text) => {
        const results = await yandexApi.getSuggestions(text);
        if (!results.length) {
            setSuggestions([]);
            return;
        }
        setSuggestions(filterResultsByCountry(results, COUNTRY_NAME));
    };
    const handleInputChange = (event) => {
        const inputValue = event.target.value;
        onChange?.(event);
        if (inputValue.length) {
            fetchSuggestions(inputValue);
        }
        else {
            setSuggestions([]);
        }
    };
    const handleSuggestionClick = (suggestion) => {
        const address = prepareYandexAutocompleteResults(suggestion);
        setSuggestions([]);
        onPlace?.(address);
    };
    return (_jsxs("div", { className: styles.yandexPlaceInputWrapper, children: [_jsx(DEPRECATED_TextInput, { ...props, "aria-label": __("address_fields.street_name"), dataTestId: "yandex-place-input", autoComplete: "street-name", value: value, onChange: handleInputChange, ref: ref }), suggestions.length > 0 && (_jsx("div", { ref: dropDownContainerRef, className: styles.yandexDropdownContainer, children: suggestions.map((suggestion, index) => (_jsx("button", { type: "button", onClick: () => handleSuggestionClick(suggestion), className: styles.yandexDropdownItem, children: suggestion.address.formatted_address }, `${suggestion.address.formatted_address}-${index}`))) }))] }));
});
//# sourceMappingURL=YandexPlaceInput.js.map